module.exports = __webpack_public_path__ + "img/address.e30c5185.png";